export const pt = {
  heading: "Sobre <highlight>mim</highlight>",
  lead: "Olá 👋, sou engenheiro back-end Node.js com mais de 6 anos de experiência construindo APIs, serviços backend e sistemas com IA.",
  paragraph1:
    "Costumo trabalhar perto de times de produto e engenharia, transformando ideias em sistemas manuteníveis com planejamento claro, decisões técnicas pragmáticas e entrega confiável.",
  paragraph2:
    "Valorizo muito comunicação, ownership e resolução de problemas. Também acredito que novas features de produto devem ser documentadas com contexto suficiente para ajudar os times a manter, evoluir e usar essas entregas com confiança.",
  facts: {
    locationLabel: "Localização",
    location: "Bahia, Brasil",
    languagesLabel: "Idiomas",
    languages: "Português, Inglês",
    statusLabel: "Status",
    status: "Open to work",
  },
  cards: [
    {
      icon: "plugsConnected" as const,
      accent: "accent" as const,
      title: "APIs & serviços",
      description:
        "APIs e serviços backend em produção com TypeScript e Node.js, usando frameworks como NestJS, com foco em manutenibilidade, confiabilidade e entrega contínua.",
    },
    {
      icon: "brain" as const,
      accent: "green" as const,
      title: "Sistemas de IA",
      description:
        "Sistemas de IA em produção usando workflows multi-agente, RAG, ferramentas MCP, pipelines de avaliação e automações internas.",
    },
    {
      icon: "database" as const,
      accent: "accent" as const,
      title: "Engenharia assistida por IA",
      description:
        "Desenvolvimento de software acelerado por Claude Code, Cursor, OpenCode, T3 Code e Conductor, com apoio de MCPs, skills reutilizáveis e workflows estruturados de planejamento.",
    },
  ],
};
